import { useTranslation } from "react-i18next";
import { Field } from "../../components/neu/Field";
import { DocumentUpload } from "./DocumentUpload";

const Hint = ({ error, rule, kind }) => {
  const { t } = useTranslation();
  if (!error) return null;
  const min = kind === "id" ? rule?.id_min : rule?.pp_min;
  const max = kind === "id" ? rule?.id_max : rule?.pp_max;
  return (
    <p className="mt-1 text-[11px] font-semibold text-danger" data-testid={`error-${kind}`}>
      {t(`personal.inline.${error}`, { min, max })}
    </p>
  );
};

export const IdentityFields = ({ personal, setPersonal, rule, errors }) => {
  const { t } = useTranslation();
  const locked = !rule;
  const range = (kind) =>
    rule ? ` (${kind === "id" ? rule.id_min : rule.pp_min}-${kind === "id" ? rule.id_max : rule.pp_max})` : "";

  return (
    <>
      <div>
        <Field
          label={`${t("personal.nationalId")}${range("id")}`}
          testId="employee-national-id"
          value={personal.national_id || ""}
          onChange={(v) => setPersonal("national_id", rule?.id_digits ? v.replace(/\D/g, "") : v)}
          disabled={locked}
          maxLength={rule?.id_max}
          inputMode={rule?.id_digits ? "numeric" : "text"}
          placeholder={locked ? t("personal.selectCountryFirst") : ""}
        />
        <Hint error={errors.national_id} rule={rule} kind="id" />
      </div>
      <Field
        label={t("personal.nationalIdExpiry")}
        testId="employee-national-id-expiry"
        type="date"
        value={personal.national_id_expiry || ""}
        onChange={(v) => setPersonal("national_id_expiry", v)}
        disabled={locked}
      />
      <div>
        <Field
          label={`${t("personal.passport")}${range("pp")}`}
          testId="employee-passport"
          value={personal.passport_number || ""}
          onChange={(v) => setPersonal("passport_number", v.toUpperCase())}
          disabled={locked}
          maxLength={rule?.pp_max}
          placeholder={locked ? t("personal.selectCountryFirst") : ""}
        />
        <Hint error={errors.passport_number} rule={rule} kind="pp" />
      </div>
      <Field
        label={t("personal.passportExpiry")}
        testId="employee-passport-expiry"
        type="date"
        value={personal.passport_expiry || ""}
        onChange={(v) => setPersonal("passport_expiry", v)}
        disabled={locked}
      />
      <DocumentUpload
        label={t("personal.nationalIdFile")}
        kind="national_id"
        value={personal.national_id_file}
        onChange={(v) => setPersonal("national_id_file", v)}
        testId="employee-national-id-file"
      />
      <DocumentUpload
        label={t("personal.passportFile")}
        kind="passport"
        value={personal.passport_file}
        onChange={(v) => setPersonal("passport_file", v)}
        testId="employee-passport-file"
      />
    </>
  );
};
